module.exports = __webpack_public_path__ + "img/f465b9a.png";